export default "__VITE_ASSET__DK0IhV8p__"